export default "__VITE_ASSET__eb97b544__"